/**
 * Converts Typesense field names to human-readable display names
 * Includes specific cases for important fields and fallback logic for others
 */
export const getFieldDisplayName = (fieldName: string): string => {
  const cleanField = fieldName.replace(/_facet$/, '');

  // Case statement for known important fields
  switch (cleanField) {
    // Shipment identifiers
    case 'shipium_shipment_id':
      return 'Shipium Shipment ID';
    case 'partner_shipment_id':
      return 'Partner Shipment ID';
    case 'shipium_label_id':
      return 'Shipium Label ID';
    case 'carrier_selection_id':
      return 'Carrier Selection ID';
    case 'fulfillment_context_id':
      return 'Fulfillment Context ID';

    // Tracking and carrier information
    case 'carrier_tracking_ids':
      return 'Carrier Tracking ID';
    case 'shipium_tracking_id':
      return 'Shipium Tracking ID';
    case 'carrier_shipment_ids':
      return 'Carrier Shipment ID';
    case 'carrier_id':
      return 'Carrier';
    case 'carrier_service_method_id':
      return 'Service Method';

    // Location information
    case 'destination_postal_code':
      return 'Destination Postal Code';
    case 'origin_postal_code':
      return 'Origin Postal Code';
    case 'destination_state':
      return 'Destination State';
    case 'origin_state':
      return 'Origin State';
    case 'destination_country_code':
      return 'Destination Country';
    case 'origin_country_code':
      return 'Origin Country';

    // Business information
    case 'tenant_id':
      return 'Tenant';
    case 'origin_id':
      return 'Origin';
    case 'order_product_id':
      return 'Order Product ID';
    case 'partner_reference_identifier':
      return 'Partner Reference ID';

    // Status and labels
    case 'label_status':
      return 'Label Status';
    case 'carrier_selection_status':
      return 'Carrier Selection Status';
    case 'shipment_type':
      return 'Shipment Type';

    // Tags and properties
    case 'shipment_tags':
      return 'Shipment Tags';
    case 'shipment_properties':
      return 'Shipment Properties';

    // Package information
    case 'package_scannable_ids':
      return 'Package Scannable ID';

    // Dates (though these are less likely to be searched as strings)
    case 'created_date_time':
      return 'Created Date';
    case 'shipped_date_time':
      return 'Shipped Date';

    // Custom label entries
    case '_custom_label_entries':
      return 'Custom Label Value';

    default:
      // Fallback: Convert snake_case to Proper Case
      return cleanField
        .split('_')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
  }
};
